<template>
	<article class="p-3 article" style="text-align: center">
		<p>{{ message }}</p>
		<b-button
			v-if="actionLabel"
			type="is-primary"
			size="is-small"
			class="mt-2"
			@click="$emit('action')"
		>
			{{ actionLabel }}
		</b-button>
	</article>
</template>

<script>
/**
 * Shared empty state: one consistent look for "nothing here yet",
 * with an optional action button naming the obvious next step.
 */
export default {
	name: "EmptyState",
	props: {
		message: {
			type: String,
			required: true,
		},
		actionLabel: {
			type: String,
			default: "",
		},
	},
};
</script>
